import { render, staticRenderFns } from "./businessChangeApply.vue?vue&type=template&id=3ff6d6e0&"
import script from "./businessChangeApply.vue?vue&type=script&lang=js&"
export * from "./businessChangeApply.vue?vue&type=script&lang=js&"
import style0 from "./businessChangeApply.vue?vue&type=style&index=0&id=3ff6d6e0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports